//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, litigationDocketCaseUrl } from "@/services/constants";
import TimeLineOperations from "../timeline/TimeLineOperations.vue";
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";
import Swal from 'sweetalert2'
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
const moment = require("moment-timezone");
export default {
    name: "CaseDocket",
    data() {
        return {
            quotationscheckstatus: '',
            statusCloseEditMode: false,
            invoiceList: [],
            // requestPaymentDisabled: true,
            invoiceMenu: false,
            invoiceMenuPay: false,
            formValid: false,
            form: {
                internalCaseNo: "####",
                blackNo: "",
                clientId: null,
                redNo: "",
                charge: "",
                court: null,
                department: null,
                caseType: null,
                courtLevel: "ศาลชั้นต้น",
                lawyerId: null,
                claimAmount: "",
                plaintiffs: "",
                defendants: "",
                hearings: [{ id: 0, topic: "", date: "", time: "", menu: false }],
                remark: "",
                caseStatus: 0,
                customerName: "",
                currency: "",
                salesOrderId: "",
                price: "",
                invoiceStatus: "",
                invoiceNo: "",
                invoiceDate: "",
                dueDate: "",
                files: [],
            },
            deletedHearings: [],
            pendingFiles: [],
            additionalLawyers: [],
            originalAdditionalLawyers: [],
            showCoLawyer: false,
            clientList: [
                // { id: 1, name: "บจก. เอ็ม-ไวบ์" },
                // { id: 2, name: "นางสาวอรอนงค์" },
                // { id: 3, name: "บมจ. ไทยเทค" },
            ],
            courtList: [
                // "ศาลแพ่ง", "ศาลอาญา", "ศาลแรงงาน", "ศาลปกครอง"
            ],
            departmentList: [
                // "แผนกคดีผู้บริโภค", "แผนกคดีทรัพย์สินทางปัญญา"
            ],
            caseTypeList: [
                // "แพ่ง", "อาญา", "ล้มละลาย", "ปกครอง"
            ],
            courtLevelList: [
                // "ศาลชั้นต้น", "ศาลอุทธรณ์", "ศาลฎีกา"
            ],

            lawyerList: [
                // { id: 1, name: "ทนายสมศักดิ์" },
                // { id: 2, name: "ทนายปรียา" },
            ],
            salesOrderList: [],
            invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],

            rules: {
                required: (v) => !!v || "จำเป็นต้องกรอก",
            },
            deletedFiles: [],
            //timeline 
            timelineStatus: 0,
            status_note: "",
            visible_check: false,
            dialogDelete: false,
            timeline_case_id: 0,
            module_name: "Dispute Resolution",
            modeOperations: "",
            tabselect: 0,
            reportlist: [],
            statuslist: [
                // "รับเรื่อง",
                // "ยื่นฟ้อง",
                // "สืบพยาน",
                // "รอคำพิพากษา",
                // "อุทธรณ์/ฎีกา",
                // "ปิดคดี",
            ],

        };
    },
    components: {
        TimeLineOperations,
        InvoiceSectionPanel
    },
    computed: {
        nonCloseStatus() {
            return this.modeOperations === "Edit" ? !this.statusCloseEditMode : true;
        },
        requestPaymentDisabled() {
            const price = Number(this.form.price);
            const salesOrderId = Number(this.form.salesOrderId);
            const customerID = Number(this.form.clientId);

            const isPriceValid = !isNaN(price) && price > 0;
            const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
            const isCustomerIdValid = !isNaN(customerID) && customerID > 0;

            return !(isPriceValid && isSalesOrderIdValid && isCustomerIdValid);
        },
        coLawyerList() {
            // ตัดทนายหลักออกจากตัวเลือกทนายร่วม
            return this.lawyerList.filter(l => l.id !== this.form.lawyerId);
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            // ----------------- Check Authorize ID ---------------------------
            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            // ----------------- Resolve Current Route Path -------------------
            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            // ----------------- Fetch Authorization --------------------------
            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            // ----------------- Check Login Status ---------------------------
            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }

            await this.loaddataLitigationCourt()
            await this.loaddataLitigationCourtLevel()
            await this.loaddataLitigationCourtCasetype()
            await this.loaddataLitigationCourtDepartment()
            await this.loaddataClientList()
            await this.loaddataLawyerList()
            await this.loaddataSalesOrder()
            await this.loaddataLitigationCourtStatus()
            // ----------------- Resolve Mode (New / Edit) --------------------
            const id = this.$route.params.id;
            if (id === "new") {
                // โหมดสร้างใหม่
                this.modeOperations = "New";
                // this.caseId = null;
                // ฟอร์มว่างไว้ตามค่า default ใน data() อยู่แล้ว
                // await this.loadDataDocrunningNew()
            } else {
                // โหมดแก้ไข — id เป็นตัวเลข
                this.modeOperations = "Edit";
                // this.caseId = id;
                this.timeline_case_id = Number(id);
                await this.loadData(id);
                await this.loadFile(id);
                await this.loadAdditionalLawyers(id);
                await this.loadHearings(id);
                await this.loadDataInvoice(id);
            }

        } catch (error) {
            console.error("mounted() error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        } finally {
            this.$hideLoader();
        }
    },
    beforeRouteUpdate(to, from, next) {
        // route เปลี่ยน id แต่ component ตัวเดิม -> สั่งรีโหลดหน้าทั้งหมด
        next();
        location.reload();
    },
    methods: {

        async loaddataLitigationCourt() {
            try {
                const res = await api.dispute_resolution_getall_court();
                this.courtList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourt error:", error);
            }
        },

        async loaddataLitigationCourtLevel() {
            try {
                const res = await api.dispute_resolution_getall_courtlevel();
                this.courtLevelList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtLevel error:", error);
            }
        },
        async loaddataLitigationCourtCasetype() {
            try {
                const res = await api.dispute_resolution_getall_courttype();
                this.caseTypeList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtCasetype error:", error);
            }
        },
        async loaddataLitigationCourtDepartment() {
            try {
                const res = await api.dispute_resolution_getall_courtdepartment();
                this.departmentList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtDepartment error:", error);
            }
        },
        async loaddataClientList() {
            try {
                const res = await api.dispute_resolution_get_clienList(Number(localStorage.getItem(server.COMPANYID)));
                this.clientList = res.data || [];
            } catch (error) {
                console.error("loaddataClientList error:", error);
            }
        },
        async loaddataLawyerList() {
            try {
                const res = await api.dispute_resolution_get_lawyerList(Number(localStorage.getItem(server.COMPANYID)));
                this.lawyerList = res.data.data || [];
            } catch (error) {
                console.error("loaddataLawyerList error:", error);
            }
        },
        async loaddataSalesOrder() {
            try {
                const res = await api.dispute_resolution_get_quotationsList(Number(localStorage.getItem(server.COMPANYID)));
                this.salesOrderList = res.data.data || [];

            } catch (error) {
                console.error("loaddataSalesOrder error:", error);
            }
        },
        async loadDataDocrunningNew() {
            try {
                const res = await api.dispute_resolution_get_docruningDocket(Number(localStorage.getItem(server.COMPANYID)));
                // เซ็ตเลขรันที่ได้ลงช่อง "รหัสคดีภายใน"
                this.form.internalCaseNo = res.data.data || "";
            } catch (error) {
                console.error("loadDataDocrunningNew error:", error);
            }
        },
        async loadData(id) {
            try {
                const res = await api.dispute_resolution_getbyid_docket(Number(id));
                const d = res.data[0];

                this.form.internalCaseNo = d.internal_case_no || "";
                this.form.blackNo = d.black_no || "";
                this.form.clientId = d.client_id || null;
                this.form.redNo = d.red_no || "";
                this.form.charge = d.charge || "";
                this.form.court = d.court ?? null;
                this.form.department = d.department ?? null;
                this.form.caseType = d.case_type ?? null;
                this.form.courtLevel = d.court_level ?? "ศาลชั้นต้น";
                this.form.lawyerId = d.lawyer_id || null;
                this.form.claimAmount = d.claim_amount || "";
                this.form.plaintiffs = d.plaintiffs || "";
                this.form.defendants = d.defendants || "";
                this.form.remark = d.remark || "";
                this.form.caseStatus = d.case_status != null ? Number(d.case_status) : 0;

                const selectedItem = this.statuslist.find(
                    item => Number(item.module_id) === Number(this.form.caseStatus)
                );
                if (selectedItem) {
                    this.statusCloseEditMode = selectedItem.status === "ปิดคดี";
                    this.timelineStatus = Number(selectedItem.timeline_status_id);
                } else {
                    this.statusCloseEditMode = false;
                    this.timelineStatus = 0;
                }

                this.form.salesOrderId = d.sales_order_id || "";
                // ค้น object เองตอนโหลดข้อมูลเดิม เพราะไม่ได้ผ่าน event จาก component
                const so = this.salesOrderList.find(
                    item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                );
                this.onSelectSO(so || null);
            } catch (error) {
                console.error("loadData error:", error);
            }
        },
        async loadAdditionalLawyers(id) {
            try {
                const res = await api.dispute_resolution_getbyid_additional_lawyers(id)
                this.additionalLawyers = res.data.map(item => item.user_id);
                this.originalAdditionalLawyers = [...this.additionalLawyers]; // เก็บค่าเดิม
                if (this.additionalLawyers.length > 0) {
                    this.showCoLawyer = true;
                }
            } catch (error) {
                console.error("loadAdditionalLawyers error:", error);
            }
        },
        async loadHearings(id) {
            try {
                const res = await api.dispute_resolution_getbyid_hearings(id)
                this.form.hearings = (res.data || []).map(item => ({
                    id: item.id,
                    topic: item.topic || "",
                    date: item.date || "",
                    time: item.time ? item.time.slice(0, 5) : "",
                    menu: false,
                }));

            } catch (error) {
                console.error("loadHearings error:", error);
            }
        },
        async loadDataInvoice(id) {
            try {
                var dataserach = {
                    module_name: 'Litigations',
                    module_id: id,
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                }
                const res = await api.dispute_resolution_get_invoiceList({
                    params: dataserach
                })
                this.invoiceList = res.data.data || [];
            } catch (error) {
                console.error("loadDataInvoice error:", error);
            }
        },
        async loadFile(id) {
            try {
                const res = await api.dispute_resolution_load_file(id, Number(localStorage.getItem(server.COMPANYID)));

                this.form.files = (res.data || []).map(item => ({
                    id: item.id,
                    name: item.file_name,
                    url: `${litigationDocketCaseUrl}/${item.module_id}/${item.file_name}`,
                    raw: null,        // ไฟล์เดิมจาก server ไม่มี raw
                    isExisting: true, // ธงบอกว่าเป็นไฟล์เก่า (เผื่อ logic ตอน save/delete)
                }));
            } catch (error) {
                console.error("loadFile error:", error);
            }
        },
        //timelinestatus
        closeDelete() {
            this.dialogDelete = false;
        },
        deleteItemConfirm() {
            this.tabselect = 1;
            this.dialogDelete = false;
        },

        handleRequestStatus(value) {
            this.form.caseStatus = Number(value)
        },
        sendToStatus(value) {
            const selectedItem = this.statuslist.find(
                item => item.module_id === value
            )
            this.timelineStatus = Number(selectedItem.timeline_status_id)
        },
        previewInvoice(item) {
            const routeData = this.$router.resolve(
                `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
            );
            window.open(routeData.href, '_blank');
        },
        async loaddataLitigationCourtStatus() {
            const result = await api.getClientTimelineStatusCongFigByModule("Dispute Resolution");

            this.statuslist = (result.data || []).map(item => ({
                ...item,
                module_id: Number(item.module_id)
            }));

        },
        //end

        openTimePicker(event) {
            const input = event.target.closest('.v-text-field')?.querySelector('input[type="time"]');
            if (input && typeof input.showPicker === 'function') {
                input.showPicker();
            }
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        onMainLawyerChange() {
            if (!this.form.lawyerId) {
                // ถ้าล้างทนายหลัก ปิดช่องทนายร่วม + เคลียร์
                this.showCoLawyer = false;
                this.additionalLawyers = [];
                return;
            }
            // ถ้าเลือกทนายหลักชนกับทนายร่วม ให้ดึงออก
            this.additionalLawyers = this.additionalLawyers.filter(
                id => id !== this.form.lawyerId
            );
        },
        closeCoLawyer() {
            this.showCoLawyer = false;
            this.additionalLawyers = [];
        },
        addHearing() {
            this.form.hearings.push({ id: 0, topic: "", date: "", time: "", menu: false });
        },
        removeHearing(index) {
            const h = this.form.hearings[index];
            if (h.id && h.id !== 0) {
                this.deletedHearings.push(h.id);
            }
            this.form.hearings.splice(index, 1);
            // กันลิสต์ว่าง — ให้มีแถวเปล่าไว้กรอกเสมอ
            if (this.form.hearings.length === 0) {
                this.form.hearings.push({ id: 0, topic: "", date: "", time: "", menu: false });
            }
        },
        onFilesSelected(files) {
            if (!files || !files.length) return;
            const list = Array.isArray(files) ? files : [files];

            list.forEach(file => {
                if (file.type !== 'application/pdf') return;   // ✅ เช็คในนี้ ทีละไฟล์

                const uniqueName = this.getUniqueName(file.name);
                const finalFile = uniqueName === file.name
                    ? file
                    : new File([file], uniqueName, { type: file.type });

                this.form.files.push({
                    name: uniqueName,
                    raw: finalFile,
                    url: URL.createObjectURL(finalFile),
                });
            });

            this.pendingFiles = [];
        },

        getUniqueName(name) {
            const existing = this.form.files.map(f => f.name);
            if (!existing.includes(name)) return name;

            // แยกชื่อกับนามสกุล
            const dot = name.lastIndexOf('.');
            const base = dot === -1 ? name : name.slice(0, dot);
            const ext = dot === -1 ? '' : name.slice(dot);

            let i = 1;
            let candidate = `${base}_${i}${ext}`;
            while (existing.includes(candidate)) {
                i++;
                candidate = `${base}_${i}${ext}`;
            }
            return candidate;
        },

        previewFile(f) {
            // เปิด PDF ในแท็บใหม่
            window.open(f.url, '_blank');
        },

        removeFile(index) {
            const f = this.form.files[index];

            if (f.isExisting) {
                // ไฟล์เก่าจาก server → จำไว้เพื่อไปลบตอน save
                this.deletedFiles.push({
                    id: f.id,
                    name: f.name,
                });
            } else if (f.url) {
                // ไฟล์ใหม่ → คืน memory ของ object URL
                URL.revokeObjectURL(f.url);
            }

            this.form.files.splice(index, 1);
        },
        onSelectSO(so) {
            // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
            if (!so) {
                this.form.price = "";
                this.form.customerName = "";
                this.form.currency = "";
                this.quotationscheckstatus = "";
                return;
            }
            this.quotationscheckstatus = so.status;
            this.form.price = Number(so.subtotal);
            this.form.customerName = so.customer_name || "";
            this.form.currency = so.currency || "";
        },

        async onSave(mode) {

            if (this.$refs.form.validate()) {


                // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าที่เลือกในคดีนี้
                // กันเคสผูก Quotation ของลูกค้าคนอื่นเข้ากับคดี ทำให้วางบิลผิดคน
                if (this.form.salesOrderId) {
                    const selectedSO = this.salesOrderList.find(
                        item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                    );

                    if (!selectedSO) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }

                    if (Number(selectedSO.client_id) !== Number(this.form.clientId)) {
                        Swal.fire({
                            icon: "warning",
                            title: "ข้อมูลลูกค้าไม่ตรงกัน",
                            html: `ใบเสนอราคา <b>${selectedSO.doc_no}</b> เป็นของลูกค้า <b>${selectedSO.customer_name || "-"}</b><br/>
                           ซึ่งไม่ตรงกับลูกค้าที่เลือกในคดีนี้<br/>
                           กรุณาตรวจสอบและเลือกใหม่ให้ถูกต้อง`,
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                }
                if (this.timelineStatus == 0 || this.status_note.trim() == "") {
                    this.dialogDelete = true;
                    return;
                }
                // helper: แปลง string ว่าง / undefined ให้เป็น null
                const toNull = (v) => (v === "" || v === undefined || v === null ? null : v);
                // helper: แปลงเป็นตัวเลข ถ้าว่างเป็น null
                const toNumber = (v) => {
                    if (v === "" || v === undefined || v === null) return null;
                    const n = Number(v);
                    return isNaN(n) ? null : n;
                };

                const resdoc = await api.dispute_resolution_get_docruningDocket(Number(localStorage.getItem(server.COMPANYID)));
                // เซ็ตเลขรันที่ได้ลงช่อง "รหัสคดีภายใน"
                this.form.internalCaseNo = resdoc.data.data || "";

                var datalist = {
                    internal_case_no: this.form.internalCaseNo,           // required - ไม่ดัก
                    black_no: toNull(this.form.blackNo),
                    client_id: toNumber(this.form.clientId),              // required (bigint)
                    red_no: toNull(this.form.redNo),
                    charge: toNull(this.form.charge),
                    court: toNumber(this.form.court),                     // int
                    department: toNumber(this.form.department),           // int
                    case_type: toNumber(this.form.caseType),              // int
                    court_level: toNumber(this.form.courtLevel),          // int *
                    claim_amount: toNumber(this.form.claimAmount),        // numeric
                    lawyer_id: toNumber(this.form.lawyerId),              // required (bigint)
                    plaintiffs: toNull(this.form.plaintiffs),
                    defendants: toNull(this.form.defendants),
                    remark: toNull(this.form.remark),
                    case_status: toNumber(this.form.caseStatus),          // bigint
                    sales_order_id: toNumber(this.form.salesOrderId),     // bigint
                    user_update: Number(localStorage.getItem(server.USER_ID)),
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                };
                try {
                    await this.$showLoader()
                    var res = [];
                    if (this.modeOperations == "New") {
                        datalist.user_create = Number(localStorage.getItem(server.USER_ID));
                        res = await api.dispute_resolution_add_docket(datalist)
                        var main_id = res.data.id;

                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(main_id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)
                        try {
                            const caseDetailResult = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

                            const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const timelineData = visibilityResult.data || [];

                            caseInfo.status = timelineData[0]?.status || '';
                            caseInfo.lastUpdated = timelineData[0]?.status_time || '';

                            const latestUpdate = {
                                message: timelineData[0]?.status_note || '',
                                date: timelineData[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo,
                                    latestUpdate,
                                    timelineData,
                                    caseId: Number(main_id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline 

                        if (this.additionalLawyers.length > 0) {
                            for (const [index, item] of this.additionalLawyers.entries()) {
                                var dataAdditionalLawyers = {
                                    litigation_docket_id: main_id,
                                    user_id: item,
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID))
                                }
                                await api.dispute_resolution_add_additional_lawyers(dataAdditionalLawyers)
                            }

                        }

                        for (const [index, item] of this.form.hearings.entries()) {
                            if (item.date != "" && item.time != "" && item.topic != "") {
                                var dataaddhearings = {
                                    litigation_docket_id: Number(main_id),
                                    topic: item.topic,
                                    date: item.date,
                                    time: item.time,
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID))
                                };



                                await api.dispute_resolution_add_hearings(dataaddhearings);
                            }
                        }
                        if (this.form.files.length > 0) {
                            for (const [index, item] of this.form.files.entries()) {
                                let formData = new FormData();
                                formData.append("file", item.raw);
                                formData.append("id", Number(main_id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                                await api.dispute_resolution_upload_file(formData)
                            }
                        }

                    } else {
                        await api.dispute_resolution_update_docket(Number(this.$route.params.id), datalist)
                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(this.$route.params.id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)

                        try {
                            const caseDetailResultEdit = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const caseInfoEdit = { ...(caseDetailResultEdit.data?.[0] || {}) };

                            const visibilityResultEdit = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const timelineDataEdit = visibilityResultEdit.data || [];

                            caseInfoEdit.status = timelineDataEdit[0]?.status || '';
                            caseInfoEdit.lastUpdated = timelineDataEdit[0]?.status_time || '';

                            const latestUpdateEdit = {
                                message: timelineDataEdit[0]?.status_note || '',
                                date: timelineDataEdit[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo: caseInfoEdit,
                                    latestUpdate: latestUpdateEdit,
                                    timelineData: timelineDataEdit,
                                    caseId: Number(this.$route.params.id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline 

                        //edit ทนายร่วม
                        const oldIds = this.originalAdditionalLawyers;
                        const newIds = this.additionalLawyers;

                        // ตัวที่เพิ่มใหม่ = อยู่ใน new แต่ไม่อยู่ใน old
                        const added = newIds.filter(id => !oldIds.includes(id));

                        // ตัวที่ถูกลบ = อยู่ใน old แต่ไม่อยู่ใน new
                        const removed = oldIds.filter(id => !newIds.includes(id));

                        // ตัวที่ไม่เปลี่ยน (ถ้าอยากรู้) = อยู่ทั้งสองฝั่ง
                        // const unchanged = newIds.filter(id => oldIds.includes(id));


                        // insert ตัวที่เพิ่ม
                        for (const item of added) {
                            await api.dispute_resolution_add_additional_lawyers({
                                litigation_docket_id: Number(this.$route.params.id),
                                user_id: item,
                                user_create: Number(localStorage.getItem(server.USER_ID)),
                                user_update: Number(localStorage.getItem(server.USER_ID))
                            });
                        }

                        // delete ตัวที่ถูกเอาออก
                        for (const item of removed) {
                            await api.dispute_resolution_delete_additional_lawyer_by_user(
                                Number(this.$route.params.id),
                                item
                            );
                        }

                        //  วันนัดพิจารณาคดี / วันนัดสืบพยาน
                        // ----- ลบตัวที่ผู้ใช้กดลบ (ของเดิม) -----

                        for (const hid of this.deletedHearings) {
                            await api.dispute_resolution_delete_hearings(hid);
                        }

                        for (const item of this.form.hearings) {
                            // ข้ามแถวที่กรอกไม่ครบ
                            if (item.date == "" || item.time == "" || item.topic == "") continue;

                            if (item.id && item.id !== 0) {
                                // ----- ของเดิม → update -----
                                await api.dispute_resolution_update_hearings(item.id, {
                                    topic: item.topic,
                                    date: item.date,
                                    time: item.time,
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                });
                            } else {
                                // ----- ของใหม่ (id = 0) → insert -----
                                await api.dispute_resolution_add_hearings({
                                    litigation_docket_id: Number(this.$route.params.id),
                                    topic: item.topic,
                                    date: item.date,
                                    time: item.time,
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                });
                            }
                        }

                        // ----- ลบไฟล์เดิมที่ผู้ใช้กดลบ -----
                        for (const f of this.deletedFiles) {
                            await api.dispute_resolution_delete_file(Number(this.$route.params.id), f.id, f.name);
                        }

                        // ----- อัปโหลดเฉพาะไฟล์ใหม่ (ไฟล์เดิมข้าม) -----
                        for (const item of this.form.files) {
                            if (item.isExisting) continue;   // ไฟล์เดิมจาก server ไม่ต้อง upload ซ้ำ
                            let formData = new FormData();
                            formData.append("file", item.raw);
                            formData.append("id", Number(this.$route.params.id));
                            formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                            formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                            await api.dispute_resolution_upload_file(formData);
                        }
                    }
                    await this.$hideLoader();
                    await Swal.fire({
                        icon: "success",
                        title: this.modeOperations == "New" ? "เพิ่มสำเร็จ" : "แก้ไขสำเร็จ",
                        text: this.modeOperations == "New"
                            ? "เพิ่มข้อมูลคดีเรียบร้อยแล้ว"
                            : "บันทึกการแก้ไขเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                    try {
                        if (this.quotationscheckstatus == "Submitted") {


                            var dataupdateStatus = {
                                status: "InProgress"
                            }
                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatus)
                        }
                    } catch (quotationsError) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                    if (mode == "Save") {

                        if (this.modeOperations == "New") {
                            this.$router.push(`/dispute-resolution-docket/${res.data.id}`);
                        } else {
                            this.$router.go(0);
                        }
                    } else {

                        var customer_name_master_show = this.clientList.find(
                            item => item.id === this.form.clientId
                        )?.name

                        var dataPush = {
                            customer_name_master: customer_name_master_show,
                            module_id: 0,
                            quotation_id: toNumber(this.form.salesOrderId),
                        }
                        if (this.modeOperations == "New") {
                            dataPush.module_id = Number(res.data.id);
                        } else {
                            dataPush.module_id = Number(this.$route.params.id);
                        }

                        this.$router.push({
                            path: `/new-free-invoice/0/invoice/D/${this.form.clientId}/Litigations`,
                            query: dataPush,
                        });
                    }
                } catch (error) {

                    Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'กรุณากรอกข้อมูลให้ครบ',
                    text: 'โปรดกรอกข้อมูล "จำเป็นต้องกรอก" ให้ครบก่อนบันทึก',
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                })
            }
        },
        onCancel() {
            this.$router.push(`/litigation-overview`);
        },
        onRequestPayment() {
            // TODO: ยิง request payment
        },
    },
    beforeDestroy() {
        this.form.files.forEach(f => {
            if (f.raw && f.url) URL.revokeObjectURL(f.url);
        });
    }
};
